(function() {
  var COOKIE_NAME = 'cbn_ref';
  var COOKIE_DAYS = 30;
  var APP_URL = 'https://cbn.pim-hub.com';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getParam(key) {
    var params = new URLSearchParams(window.location.search);
    return params.get(key);
  }

  function addCartAttribute(code) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { referral_code: code } })
    }).catch(function() {});
  }

  function trackClick(code) {
    fetch(APP_URL + '/api/affiliate/track-click', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: code })
    }).catch(function() {});
  }

  var refCode = getParam('ref');
  if (refCode) {
    setCookie(COOKIE_NAME, refCode, COOKIE_DAYS);
    trackClick(refCode);
    addCartAttribute(refCode);
  } else {
    var cookieCode = getCookie(COOKIE_NAME);
    if (cookieCode) {
      addCartAttribute(cookieCode);
    }
  }
})();